var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrendingActive = function SvgTrendingActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3529 5.29807C11.2141 5.06848 10.9394 4.95936 10.6808 5.03143C10.4224 5.1035 10.2436 5.33901 10.2436 5.6072C10.2436 6.33676 9.65006 6.93012 8.92066 6.93012C8.19125 6.93012 7.59774 6.33676 7.59774 5.6072V0.597717C7.59774 0.355983 7.45204 0.138064 7.22868 0.0456045C7.00531 -0.0470109 6.74832 0.00404431 6.57741 0.175111C6.51017 0.242198 4.9164 1.84546 3.30162 4.26762C2.34932 5.69593 1.58941 7.11271 1.04305 8.47859C0.351005 10.209 0 11.8655 0 13.4023C0 17.262 3.14021 20.4022 7.00002 20.4022C10.8597 20.4022 13.9999 17.262 13.9999 13.4023C14 10.9316 13.1094 8.20495 11.3529 5.29807ZM11.2679 10.5297C11.4582 10.3296 11.4503 10.0131 11.2502 9.82281C11.0502 9.63248 10.7337 9.64039 10.5434 9.84047L7.5653 12.9712L5.59946 11.4986L5.24375 11.2322L4.93742 11.5542L2.22423 14.4064C2.03391 14.6065 2.04182 14.923 2.2419 15.1133C2.44197 15.3036 2.75846 15.2957 2.94878 15.0957L5.35565 12.5654L7.32149 14.038L7.6772 14.3044L7.98352 13.9824L11.2679 10.5297Z",
    fill: "url(#paint0_linear_143_10003)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_143_10003",
    x1: 0,
    y1: 0,
    x2: 19.0363,
    y2: 13.0626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF015C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB807"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrendingActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trending-active.adff2561.svg";
export { ForwardRef as ReactComponent };